import React from 'react';

import { Box, Spacer, Typography, Image } from '@bcp-nextgen-dx-component-factory/design-system';
import { Call } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { ModalLocal } from '@components';
import { rem } from '@helpers';
import { modals } from '@modals';

import { useWaitingForCallHelper } from './waitingForCall.helper';

export const WaitingForCall: React.FC = () => {
	const { cerise, resources } = useWaitingForCallHelper();

	return (
		<ModalLocal
			name={modals.waitingForCall}
			middleContent={{
				content: (
					<Box
						styles={{
							flexDirection: 'column',
							alignItems: 'center',
							width: '100%',
						}}
					>
						<Image
							source={Call}
							svgProps={{
								fill: cerise,
								width: rem(72),
								height: rem(72),
							}}
						/>
						<Spacer vertical={24} />
						<Typography appearance="subtitle-200-02">{resources.title}</Typography>
						<Spacer vertical={4} />
						<Typography appearance="body-100-02">{resources.subtitle}</Typography>
					</Box>
				),
				type: 'custom',
			}}
		/>
	);
};
